function prevHomeSlide() {
    let wrapper = document.getElementById('home-projects-slider');
    let slides = document.getElementsByClassName('home-projects_img');
    let first = slides[0];
    let last = slides[slides.length - 1];
    wrapper && wrapper.removeChild(last);
    wrapper && wrapper.insertBefore(last, first);
}

function nextHomeSlide() {
    let wrapper = document.getElementById('home-projects-slider');
    let slides = document.getElementsByClassName('home-projects_img');
    let first = slides[0];
    wrapper && wrapper.removeChild(first);
    wrapper && wrapper.appendChild(first);
}

function selectHomeSocial(id) {
    let active = document.getElementsByClassName('home-socials--active');
    active && active[0] && active[0].classList.remove('home-socials--active');
    let topic = document.getElementById(id);
    topic && topic.classList.add('home-socials--active');
}

function prevHomeSocialSlide() {
    let wrapper = document.getElementById('home-socials-slider');
    let slides = document.getElementsByClassName('home-socials-slider_slide');
    let first = slides[0];
    let last = slides[slides.length - 1];
    wrapper && wrapper.removeChild(last);
    wrapper && wrapper.insertBefore(last, first);
}

function nextHomeSocialSlide() {
    let wrapper = document.getElementById('home-socials-slider');
    let slides = document.getElementsByClassName('home-socials-slider_slide');
    let first = slides[0];
    wrapper && wrapper.removeChild(first);
    wrapper && wrapper.appendChild(first);
}

module.exports = {
    prevHomeSlide, nextHomeSlide, selectHomeSocial, prevHomeSocialSlide, nextHomeSocialSlide
}

function showContentBlock(id) {
    document.querySelectorAll('.home-technologies_content').forEach(block => {
        if (block.id === id) {
            block.style.display = 'block';
        } else {
            block.style.display = 'none';
        }
    });
}

function setActiveNavItem(target) {
    document.querySelectorAll('.home-technologies_box').forEach(item => {
        if (item === target) {
            item.classList.add('active');
        } else {
            item.classList.remove('active');
        }
    });
}

function findClosestNavItem(element) {
    while (element && !element.classList.contains('home-technologies_box')) {
        element = element.parentElement;
    }
    return element;
}

document.querySelectorAll('.home-technologies_box').forEach(item => {
    item.addEventListener('click', event => {
        const navItem = findClosestNavItem(event.target);
        const targetId = navItem.getAttribute('data-target');
        if (targetId) {
            showContentBlock(targetId);
            setActiveNavItem(navItem);
        }
        event.preventDefault(); // Verhindert das Standardverhalten des Browsers
    });
});

// Initialen Content-Block anzeigen
showContentBlock('content1');
